import { render, staticRenderFns } from "./DetailBackTop.vue?vue&type=template&id=791ade2b&scoped=true&"
import script from "./DetailBackTop.vue?vue&type=script&lang=js&"
export * from "./DetailBackTop.vue?vue&type=script&lang=js&"
import style0 from "./DetailBackTop.vue?vue&type=style&index=0&id=791ade2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791ade2b",
  null
  
)

export default component.exports